/**
 * author: Soumya Shreyas
 */

import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal, Form } from "react-bootstrap";

function DeleteSectionModal({ modalShow, callbackModal }) {
  const [show, setShow] = useState(modalShow);
  const [selDeleteType, setDeleteType] = useState('');
  const [validated, setValidated] = useState(false);

  const handleClose = () => {
    setShow(false);
    callbackModal(false);
  };
  const handleConfirm = () => {

    if (!selDeleteType) {
      setShow(true);
    } else {
      setShow(false);
      let type = selDeleteType === "true" ? selDeleteType : '';
      callbackModal(true, type);
    }

    setValidated(true);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="builder-ui-modal"
      >
        <Modal.Header closeButton className="builder-ui-modal__header">
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="builder-ui-modal__body">
          <Form noValidate validated={validated}>
            <Form.Group className="mb-3">
              <Form.Check
                inline
                type="radio"
                label="Delete all the questions in this section"
                name="deleteType"
                value="true"
                required
                onChange={(e) => setDeleteType(e.target.value)}
                id="deleteType1"

              />
              <Form.Check
                inline
                type="radio"
                label="Move all the questions to the above section"
                name="deleteType"
                required
                value="false"
                onChange={(e) => setDeleteType(e.target.value)}
                id="deleteType2"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="builder-ui-modal__footer">
          <button  onClick={handleClose} autoFocus className="builder-ui-btn builder-ui-btn--secondary">
            Cancel
          </button>
          <button  onClick={handleConfirm} className="builder-ui-btn builder-ui-btn--primary px-4">
            Ok
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteSectionModal;
